class Rest {
    constructor() {
        //this.endpoint = "http://smsrapidos.itrcenter.com/api/v1/";
        //this.endpoint = "http://smsmasivos.local/api/v1/";
        this.endpoint="http://srv1.smsrapidos.com/api/v1/";
    }

    /**
     * 
     * @param {array state} stateData 
     * @param {endpoint + path} path 
     * @param {array key post} key 
     */
    async post(stateData, path, key, dataHeaders) {
        let headers = new Headers();
        headers.set('WWW-Authenticate', dataHeaders.token);
        let url = this.endpoint + path;
        var data = new FormData();
        data.append(key, JSON.stringify(stateData));
        let req = await fetch(url, {
            headers: headers,
            method: 'POST',
            body: data
        })
        let response = await req.json();
        return Promise.resolve(response);
    }

    async registro(stateData, path, key) {
        let url = this.endpoint + path;
        var data = new FormData();
        data.append(key, JSON.stringify(stateData));
        let req = await fetch(url, {
            method: 'POST',
            body: data
        })
        let response = await req.json();
        return Promise.resolve(response);
    }

    async login(path, token) {
        let headers = new Headers();
        headers.set('Authorization', 'Basic ' + token);
        let url = this.endpoint + path;
        let req = await fetch(url, {
            headers: headers,
            method: 'POST'
        })
        let response = await req.json();
        return Promise.resolve(response);
    }

    async put(stateData, path, key, token) {
        let headers = new Headers();
        headers.set('WWW-Authenticate', token);
        let url = this.endpoint + path;
        var data = new FormData();
        data.append(key, JSON.stringify(stateData));
        let req = await fetch(url, {
            headers: headers,
            method: 'PUT',
            body: data
        })
        let response = await req.json();
        return Promise.resolve(response);
    }

    /**
     * 
     * @param {enpoint + final path url api} path 
     */
    async get(path, dataHeaders = null) {
        let url = this.endpoint + path;
        if (dataHeaders !== null) {
            let headers = new Headers();
            headers.set('WWW-Authenticate', dataHeaders.token);
            let datos = await fetch(url, {
                method: "GET",
                headers: headers
            });
            const datosJson = await datos.json();
            return Promise.resolve(datosJson);
        }
        else {
            let datos = await fetch(url, {
                method: "GET"
            });
            const datosJson = await datos.json();
            return Promise.resolve(datosJson);
        }
    }

    /**
     * 
     * @param {enpoint + final path url api + key p.ej. enpoint/server/id} path 
     */
    async delete(path, dataHeaders) {
        let headers = new Headers();
        headers.set('WWW-Authenticate', dataHeaders.token);
        let url = this.endpoint + path;
        let req = await fetch(url, {
            method: "delete",
            headers: headers
        });
        let reqJson = await req.json();
        return Promise.resolve(reqJson);
    }

    async patch(stateData, path, key, token) {
        let headers = new Headers();
        headers.set('WWW-Authenticate', token);
        let url = this.endpoint + path;
        var data = new FormData();
        data.append(key, JSON.stringify(stateData));
        let req = await fetch(url, {
            method: 'PATCH',
            body: data,
            headers: headers
        })
        let response = await req.json();
        return Promise.resolve(response);
    }

}
export default Rest;


// WEBPACK FOOTER //
// ./src/services/Rest.js